import { cloneElement, isValidElement } from "react";
import Col from "../layout/Col";
import Row from "../layout/Row";

import { ListGroupItem } from "./ListGroup";
import TrashIcon from "../icon/TrashIcon";
import Grid from "../layout/Grid";
import Button from "./Button";
import PencilIcon from "../icon/PencilIcon";

export default function ListGroupObjectItem({
  index,
  value,
  indexLabel,
  deletable,
  onDelete,
  editable,
  onEdit,
  children,
  className,
  disabled,
  ...props
}) {
  const computedClassName = ["list-group-object-item", ...className.split(" ")]
    .join(" ")
    .trim();
  return (
    <ListGroupItem className={computedClassName} {...props}>
      <Grid>
        <Row>
          <Col lg={12}>
            <span
              style={{
                float: "right",
                alignContent: "center",
                marginTop: "0.5em",
              }}
            >
              {!!deletable && !disabled && (
                <Button
                  sm
                  style={{ margin: 0, fontSize: "16px" }}
                  variant="danger"
                  iconBefore={<TrashIcon />}
                  onClick={onDelete}
                />
              )}
              {!!editable && !disabled && (
                <Button
                  sm
                  style={{ margin: 0, fontSize: "16px" }}
                  variant="default"
                  iconBefore={<PencilIcon />}
                  onClick={onEdit}
                />
              )}
            </span>
            {index !== undefined && (
              <h5 style={{ float: "left" }}>
                {indexLabel}&nbsp;{index + 1}
              </h5>
            )}
            {index === undefined && (
              <h5 style={{ float: "left" }}>{indexLabel}</h5>
            )}
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            {children instanceof Function && children({ value })}
            {isValidElement(children) && cloneElement(children, { value })}
          </Col>
        </Row>
      </Grid>
    </ListGroupItem>
  );
}

ListGroupObjectItem.defaultProps = {
  className: "",
};
